<div class="content">
  <div class="login sign-up">
    <div class="login-logo-odm">
      <img src="{{logoPath}}">
    </div>
    <form (ngSubmit)="resetPassword(resetPasswordForm)" #resetPasswordForm="ngForm">
      <div class="login-content">
        <h3><span>{{'Reset Password' | translate}}</span>{{'You have requested to reset your password' | translate}}</h3>

        <div class="form-group">
          <label for="" class="col-form-label" translate>Account</label>
          <div>
            <input type="text" pInputText class="pInputText" disabled placeholder="User@powermastercloud.com" name="Account" [value]="ChangePasswordInfo.Account">
          </div>
        </div>

        <div class="form-group">
          <label for="" class="col-form-label" translate>New Password</label>
          <div>
            <input type="password" pPassword id="password" class="pInputText" name="NewPassword" [(ngModel)]="ChangePasswordInfo.NewPassword" required #password="ngModel">
            <p-message severity="error" text="Password is required" *ngIf="(resetPasswordForm.submitted && !password.dirty) || (password.invalid && (password.dirty || password.touched))"></p-message>
          </div>
        </div>
        <div class="form-group">
          <label for="" class="col-form-label" translate>Confirm New Password</label>
          <div>
            <input type="password" pPassword id="passwordConfirm" class="pInputText" name="PasswordConfirm" [(ngModel)]="PasswordConfirm" required #passwordConfirm="ngModel">
            <p-message severity="error" text="{{'Password does not match' | translate}}" *ngIf="(passwordConfirm.value!=password.value && (passwordConfirm.touched) || (resetPasswordForm.submitted && password.valid && !passwordConfirm.touched))"></p-message>
          </div>
        </div>

        <button type="submit" pButton label="{{'Reset Password' | translate}}" class="login-btn" name="submit"></button>

      </div>
    </form>
  </div>
</div>
